<template>
    <div class="vh-100">
        <WebDataRocks
            v-if="ready"
            :key="key"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks.vue'

export default {
    name: 'FeesPivot',

    components: {
        WebDataRocks,
    },

    props: {
        type: null,
    },

    data() {
        return {
            pivotConfig: {
                dataSource: {},
                slice: {},
                options: {
                    grid: {
                        type: 'classic',
                        title: '',
                        showFilter: true,
                        showHeaders: false,
                        showTotals: true,
                        showGrandTotals: 'on',
                        showHierarchies: true,
                        showHierarchyCaptions: true,
                        showReportFiltersArea: true,
                    },
                    configuratorActive: false,
                    configuratorButton: true,
                    showAggregations: true,
                    showCalculatedValuesButton: true,
                    drillThrough: true,
                    showDrillThroughConfigurator: true,
                    sorting: 'on',
                    datePattern: 'yyyy-MM-dd',
                    dateTimePattern: 'dd/MM/yyyy HH:mm:ss',
                    saveAllFormats: false,
                    showDefaultSlice: true,
                    defaultHierarchySortName: 'asc',
                },
                formats: [
                    {
                        name: '',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 0,
                        maxSymbols: 20,
                        currencySymbol: '€',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                ],
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: null,

            key: 'wrd',
            ready: false,
        }
    },

    async created() {
        await this.getData()
    },

    methods: {
        async getData() {
            try {
                const response = await axios.get(
                    `/dashboard/fees/pivot/${this.year}`
                )
                this.pivotData = response.data
                this.setReport()
            } catch (error) {
                console.log(error)
            }
        },

        setReport() {
            if (this.type === 'firm') {
                this.setCompanyReport()
            } else if (this.type === 'client') {
                this.setClientReport()
            } else if (this.type === 'activity') {
                this.setActivityReport()
            }
        },

        setCompanyReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            this.pivotConfig.slice = {
                reportFilters: [{ uniqueName: 'Activité', sort: 'asc' }],
                rows: [{ uniqueName: 'Date.Month' }],
                columns: [{ uniqueName: 'Cabinet', sort: 'asc' }],
                measures: [{ uniqueName: 'Montant', aggregation: 'sum' }],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }
            this.ready = true
            this.key = Date.now()
        },

        setClientReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            this.pivotConfig.slice = {
                reportFilters: [{ uniqueName: 'Cabinet' }],
                rows: [
                    { uniqueName: 'Client', sort: 'asc' },
                    { uniqueName: 'Activité', sort: 'asc' },
                ],
                columns: [{ uniqueName: 'Date.Month' }],
                measures: [{ uniqueName: 'Montant', aggregation: 'sum' }],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }
            this.ready = true
            this.key = Date.now()
        },

        setActivityReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }
            this.pivotConfig.slice = {
                reportFilters: [{ uniqueName: 'Cabinet' }],
                rows: [
                    { uniqueName: 'Activité', sort: 'asc' },
                    { uniqueName: 'Client', sort: 'asc' },
                ],
                columns: [{ uniqueName: 'Date.Month' }],
                measures: [{ uniqueName: 'Montant', aggregation: 'sum' }],
                expands: {
                    expandAll: false,
                },
                drills: {
                    drillAll: false,
                },
            }
            this.ready = true
            this.key = Date.now()
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },
}
</script>

<style scoped></style>
